import styled, {css} from "styled-components"

const List = styled.ul`
  ${({theme}) => css`
    margin: ${theme.spacing.one} 0 ${theme.spacing.three} 0;
    padding: 0 ${theme.spacing.two};
  `}
`

export default List
